import { parseHtmlFromString } from 'Utils/Utility'
import { cartierDebug } from 'Utils/Debug'

const IDLE_CALLBACK_TIMEOUT = 3000
let openedOnce = false

/**
 * @function openPopup
 * @description Opens a redirect popup with the given data
 */
function openPopup(data, isoCode) {
	if (openedOnce) {
		return
	}

	openedOnce = true

	try {
		if (data !== '') {
			yTos.Cartier.popup({
				title: yTos.Cartier.labels.redirectPopupTitle,
				cssClasses: ['size-base', 'redirect-popup'],
				content: parseHtmlFromString(data, true),
				onClose: () => {
					localStorage.setItem(`car-${isoCode}-show-redirect-popup`, 'false')
				},
			})
		}
	} catch (e) {
		cartierDebug('error', e)
	}
}

/**
 * @function getRedirectPopupData
 * @description Returns a promise that fetches the redirect popup content asynchronously
 */
function getRedirectPopupData() {
	return new Promise((resolve, reject) => {
		requestIdleCallback(
			async () => {
				const isoCode = yTos.navigation?.SiteCode?.split('_')[1] ?? 'GB'
				const popupWasShown = localStorage.getItem(`car-${isoCode}-show-redirect-popup`)
				if (popupWasShown !== null || !yTos.Cartier?.EnableRedirectPopup) return

				try {
					const response = await yTos.fetch(`/Countries/RedirectPopupLayer`)
					const data = await response.text()
					resolve({ data, isoCode })
				} catch (e) {
					reject(e)
				}
			},
			{
				timeout: IDLE_CALLBACK_TIMEOUT,
			}
		)
	})
}

/**
 * @function openRedirectPopupLayer
 * @description open the redirect popup if the condition are met
 */
export const openRedirectPopupLayer = () => {
	let canOpenPopup = false
	yTos.watchOne({
		'CAR::CookieLayerClosed': () => {
			canOpenPopup = true
		},
		'TC::LoadCompleted': () => {
			canOpenPopup = true
		},
	})

	getRedirectPopupData()
		.then(({ data, isoCode }) => {
			if (
				canOpenPopup ||
				(typeof window.tc_events_19 === 'function' && !yTos.Cartier.cookiesPopupOpen)
			) {
				openPopup(data, isoCode)
				return
			}
			yTos.watchOne({
				'CAR::CookieLayerClosed': () => {
					openPopup(data, isoCode)
				},
				'TC::LoadCompleted': () => {
					openPopup(data, isoCode)
				},
			})
		})
		.catch((e) => {
			cartierDebug('error', e)
		})
}
